// Games Reducer

const wordOfDayReducerDefaultState = [];

export const wordOfDayReducer = (state = wordOfDayReducerDefaultState, action) => {
    //console.log("reducer action = " + JSON.stringify(action));
    switch (action.type) {
        case 'EDIT_WORD_OF_DAY':
            return (
                {
                    wordOfDay: state.wordOfDay,
                }
            );
        case 'SET_WORD_OF_DAY':
            return (
                {
                    wordOfDay: action.wordOfDay,
                }
            );
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/wordOfDay.js